@let content = currentRendering.selectors.content.asSignal();
@let segments = content?.tabbed ?? [];
@let currentContainer = currentRendering.selectors.currentContainer.asSignal();

<atn-ds-page>
  <atn-mosaic-page-header pageHeader />
  <!-- Tabs -->
  <div pageAside>
    <div class="atn-mosaic-segment-tabs">
      @if (
        currentRendering.subfeatures.segments.selectors.someLoading.asSignal()
      ) {
        <atn-ds-loader type="tabs" />
      } @else {
        @for (segment of segments; track $index) {
          @let additionalInfo =
            currentRendering.subfeatures.segments.selectors
              .getInfo({ alias: segment.alias })
              .asSignal();
          @if (additionalInfo) {
            @if (additionalInfo.rendering) {
              @if (!additionalInfo.rendering.isHidden) {
                <a
                  class="atn-mosaic-segment-tab"
                  [class.atn-mosaic-segment-tab--selected]="
                    segment.alias === currentContainer?.alias
                  "
                  [routerLink]="
                    currentRendering.selectors.getSegmentUrl(segment).asSignal()
                  "
                  data-test-id="segment-tab"
                >
                  {{ additionalInfo.rendering.name ?? segment.name }}
                </a>
              }
            } @else if (additionalInfo.error) {
              error...
            }
          } @else {
            <!-- NOTE: default case if there is no additional request needed -->
            <a
              class="atn-mosaic-segment-tab"
              [class.atn-mosaic-segment-tab--selected]="
                segment.alias === currentContainer?.alias
              "
              [routerLink]="
                currentRendering.selectors.getSegmentUrl(segment).asSignal()
              "
              data-test-id="segment-tab"
            >
              {{ segment.name }}
            </a>
          }
        }
      }
    </div>
  </div>

  <!-- Content -->
  @if (currentContainer) {
    <atn-mosaic-page-grid [container]="currentContainer" />
  } @else {
    <!-- TODO: empty state -->
    TODO: put the empty state here
  }
</atn-ds-page>
